import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap, of } from "rxjs";
import { ApiConnectorJoliooService } from "../../io/jolioo/api-connector-jolioo.service";
import {
  checkVoucher,
  checkVoucherError,
  checkVoucherSuccess,
  cancelVoucher,
  cancelVoucherError,
  cancelVoucherSuccess,
  confirmVoucher,
  confirmVoucherError,
  confirmVoucherSuccess,
  reserveVoucher,
  reserveVoucherError,
  reserveVoucherSuccess,
} from "./voucher.actions";

@Injectable()
export class VoucherEffects {
  checkVoucher$ = createEffect(() =>
    this._actions$.pipe(
      ofType(checkVoucher),
      mergeMap((action) =>
        this._jolioo.check(action.code, action.pharmacy).pipe(
          map((voucher) => checkVoucherSuccess({ voucher })),
          catchError((error) => of(checkVoucherError({ error }))),
        ),
      ),
    ),
  );

  /**
   * ⚠ Kein Retry-Operator auf reserve/confirm: ein Wiederholen darf nur mit
   * demselben idempotencyKey passieren, und das entscheidet die Komponente.
   */
  reserveVoucher$ = createEffect(() =>
    this._actions$.pipe(
      ofType(reserveVoucher),
      mergeMap((action) =>
        this._jolioo
          .reserve(
            action.code,
            action.pharmacy,
            action.value,
            action.idempotencyKey,
          )
          .pipe(
            map((reservation) => reserveVoucherSuccess({ reservation })),
            catchError((error) => of(reserveVoucherError({ error }))),
          ),
      ),
    ),
  );

  confirmVoucher$ = createEffect(() =>
    this._actions$.pipe(
      ofType(confirmVoucher),
      mergeMap((action) =>
        this._jolioo
          .confirm(action.code, action.pharmacy, action.idempotencyKey)
          .pipe(
            map((redemption) => confirmVoucherSuccess({ redemption })),
            catchError((error) => of(confirmVoucherError({ error }))),
          ),
      ),
    ),
  );

  cancelVoucher$ = createEffect(() =>
    this._actions$.pipe(
      ofType(cancelVoucher),
      mergeMap((action) =>
        this._jolioo
          .cancel(action.code, action.pharmacy, action.idempotencyKey)
          .pipe(
            map((response) =>
              cancelVoucherSuccess({ voucher: response.voucher }),
            ),
            catchError((error) => of(cancelVoucherError({ error }))),
          ),
      ),
    ),
  );

  constructor(
    private _actions$: Actions,
    private _jolioo: ApiConnectorJoliooService,
  ) {}
}
